module.exports = __webpack_public_path__ + "img/treeplant5_7-8-2021.7293fcac.jpg";